<!--
  ~ Copyright (c) GM Global Technology Operations LLC. All rights reserved.
  ~ This information is confidential and proprietary to GM Global Technology
  ~ Operations LLC and may not be used, modified, copied or distributed.
  -->

<fab-loading-spinner [hidden]="(!showSpinner)" color="primary"></fab-loading-spinner>
<div id="header-container">
  <h1 id="header-text">Global Propulsion Forecast Template</h1>
  <div id="actions-container">
    <button mat-raised-button color="primary" id="confirm-button" class="action-button"
            (click)="exportReport()"
            [disabled]="selectedGlobalScenario === undefined || selectedGlobalScenario === null">
      Run Report
    </button>
  </div>
</div>
<div class="content-height">
  <app-global-scenario-select-component
    [user]="stateService.getUserGmid()"
    [memberScenarioType]="0"
    [displayedMemberColumns]="displayedMemberHeaders"
    (confirmEvent)="onScenarioSelection($event)"></app-global-scenario-select-component>
</div>
